import type { Bed } from './beds'
import { bunkJoinery } from './bunk-joinery'

/** Ladder footprint in bed-local inches (x = width, y = depth; ladder at the foot end). */
export function bunkLadderLocal(b: Bed): { x: number; y: number; w: number; h: number } | null {
  if (b.ladder === false || b.kind === 'stairs' || b.kind === 'bridge' || b.kind === 'custom') return null

  const { entryX, entryWidth, frameLength, ladderDepth } = bunkJoinery(b)
  const stile = Math.min(2.25, b.width * 0.04)
  return { x: entryX - stile, y: frameLength, w: entryWidth + 2 * stile, h: ladderDepth }
}

/** Map a bed-local point (inches) to room coordinates. */
export function bedLocalToRoom(b: Bed, lx: number, ly: number): [number, number] {
  const w = b.width
  const d = b.depth
  switch (b.rotation) {
    case 90:
      return [b.x + ly, b.y + (w - lx)]
    case 180:
      return [b.x + (w - lx), b.y + (d - ly)]
    case 270:
      return [b.x + (d - ly), b.y + lx]
    default:
      return [b.x + lx, b.y + ly]
  }
}

export function bunkLadderRoomPolygon(b: Bed): [number, number][] | null {
  const ladder = bunkLadderLocal(b)
  if (!ladder) return null
  const { x, y, w, h } = ladder
  return [
    bedLocalToRoom(b, x, y),
    bedLocalToRoom(b, x + w, y),
    bedLocalToRoom(b, x + w, y + h),
    bedLocalToRoom(b, x, y + h),
  ]
}

/** Midpoint on the ladder edge that faces into the room (climb side). */
export function bunkLadderClimbHint(b: Bed): { from: [number, number]; to: [number, number] } | null {
  const ladder = bunkLadderLocal(b)
  if (!ladder) return null
  const { x, y, w, h } = ladder
  const midX = x + w / 2
  const from = bedLocalToRoom(b, midX, y + h)
  const to = bedLocalToRoom(b, midX, Math.max(0, y - Math.min(8, y)))
  return { from, to }
}
